const DEFAULT_CURRENCY = 'USD';

export const formatCentsAsCurrency = (amountCents: number, currency = DEFAULT_CURRENCY): string => {
  const amount = amountCents / 100;
  const currencyCode = currency || DEFAULT_CURRENCY;
  const format = (resolvedCurrency: string) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: resolvedCurrency,
    }).format(amount);

  try {
    return format(currencyCode);
  } catch {
    return format(DEFAULT_CURRENCY);
  }
};
